import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resourceName'
})
export class ResourceNamePipe implements PipeTransform {

  transform(value: any): any {
    return value && value.replace(/(\d)/gm, '<sub>$1</sub>');
  }

}
